declare namespace $ {

	type $mol_view__sub_shm_hitalama_vk_analysis_summary_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_hitalama_vk_analysis_summary_2 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_hitalama_vk_analysis_summary_3 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_hitalama_vk_analysis_summary_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_hitalama_vk_analysis_summary_5 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_hitalama_vk_analysis_summary_6 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_hitalama_vk_analysis_summary_7 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_hitalama_vk_analysis_summary_8 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_hitalama_vk_analysis_summary_9 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_image__uri_shm_hitalama_vk_analysis_summary_10 = $mol_type_enforce<
		ReturnType< $shm_hitalama_vk_analysis_summary['photo'] >
		,
		ReturnType< $mol_image['uri'] >
	>
	type $mol_image__title_shm_hitalama_vk_analysis_summary_11 = $mol_type_enforce<
		ReturnType< $shm_hitalama_vk_analysis_summary['owner_id'] >
		,
		ReturnType< $mol_image['title'] >
	>
	type $mol_paragraph__title_shm_hitalama_vk_analysis_summary_12 = $mol_type_enforce<
		ReturnType< $shm_hitalama_vk_analysis_summary['name'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_shm_hitalama_vk_analysis_summary_13 = $mol_type_enforce<
		ReturnType< $shm_hitalama_vk_analysis_summary['members_count'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_shm_hitalama_vk_analysis_summary_14 = $mol_type_enforce<
		ReturnType< $shm_hitalama_vk_analysis_summary['posts_counts'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_shm_hitalama_vk_analysis_summary_15 = $mol_type_enforce<
		ReturnType< $shm_hitalama_vk_analysis_summary['views'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_shm_hitalama_vk_analysis_summary_16 = $mol_type_enforce<
		ReturnType< $shm_hitalama_vk_analysis_summary['likes'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_shm_hitalama_vk_analysis_summary_17 = $mol_type_enforce<
		ReturnType< $shm_hitalama_vk_analysis_summary['reposts'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_shm_hitalama_vk_analysis_summary_18 = $mol_type_enforce<
		ReturnType< $shm_hitalama_vk_analysis_summary['comments'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_shm_hitalama_vk_analysis_summary_19 = $mol_type_enforce<
		ReturnType< $shm_hitalama_vk_analysis_summary['erv'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_shm_hitalama_vk_analysis_summary_20 = $mol_type_enforce<
		ReturnType< $shm_hitalama_vk_analysis_summary['sum_photo'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_shm_hitalama_vk_analysis_summary_21 = $mol_type_enforce<
		ReturnType< $shm_hitalama_vk_analysis_summary['sum_name'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_shm_hitalama_vk_analysis_summary_22 = $mol_type_enforce<
		ReturnType< $shm_hitalama_vk_analysis_summary['sum_members_count'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_shm_hitalama_vk_analysis_summary_23 = $mol_type_enforce<
		ReturnType< $shm_hitalama_vk_analysis_summary['sum_posts_counts'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_shm_hitalama_vk_analysis_summary_24 = $mol_type_enforce<
		ReturnType< $shm_hitalama_vk_analysis_summary['sum_views'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_shm_hitalama_vk_analysis_summary_25 = $mol_type_enforce<
		ReturnType< $shm_hitalama_vk_analysis_summary['sum_likes'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_shm_hitalama_vk_analysis_summary_26 = $mol_type_enforce<
		ReturnType< $shm_hitalama_vk_analysis_summary['sum_reposts'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_shm_hitalama_vk_analysis_summary_27 = $mol_type_enforce<
		ReturnType< $shm_hitalama_vk_analysis_summary['sum_comments'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_shm_hitalama_vk_analysis_summary_28 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_view__sub_shm_hitalama_vk_analysis_summary_29 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_hitalama_vk_analysis_summary_30 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $shm_hitalama_vk_analysis_summary extends $shm_hitalama_table {
		Head_photo( ): $mol_view
		Head_name( ): $mol_view
		Head_members_count( ): $mol_view
		Head_posts_counts( ): $mol_view
		Head_views( ): $mol_view
		Head_likes( ): $mol_view
		Head_reposts( ): $mol_view
		Head_comments( ): $mol_view
		Head_ERv( ): $mol_view
		photo( id: any): string
		owner_id( id: any): string
		Photo( id: any): $mol_image
		name( id: any): string
		Name( id: any): $mol_paragraph
		members_count( id: any): string
		Member_counts( id: any): $mol_paragraph
		posts_counts( id: any): string
		Posts_counts( id: any): $mol_paragraph
		views( id: any): string
		Views( id: any): $mol_paragraph
		likes( id: any): string
		Likes( id: any): $mol_paragraph
		reposts( id: any): string
		Reposts( id: any): $mol_paragraph
		comments( id: any): string
		Comments( id: any): $mol_paragraph
		erv( id: any): string
		ERv( id: any): $mol_paragraph
		sum_photo( ): string
		Sum_photo( ): $mol_paragraph
		sum_name( ): string
		Sum_name( ): $mol_paragraph
		sum_members_count( ): string
		Sum_members_count( ): $mol_paragraph
		sum_posts_counts( ): string
		Sum_posts_counts( ): $mol_paragraph
		sum_views( ): string
		Sum_views( ): $mol_paragraph
		sum_likes( ): string
		Sum_likes( ): $mol_paragraph
		sum_reposts( ): string
		Sum_reposts( ): $mol_paragraph
		sum_comments( ): string
		Sum_comments( ): $mol_paragraph
		Sum_ERv( ): $mol_paragraph
		token_str( ): string
		owner_ids( ): readonly(string)[]
		groups_dtos( next?: any ): any
		posts_dto_by_owner( id: any): $shm_hitalama_vk_posts_dto | null
		head( ): readonly(any)[]
		Row( id: any): $mol_view
		Sum_row( ): $mol_view
	}
	
}

//# sourceMappingURL=summary.view.tree.d.ts.map